<script lang="ts">
    interface Props {
        size?: string;
        width?: string;
        height?: string;
        color?: string;
        viewBox?: string;
    }

    let {
        size = "1em",
        width = size,
        height = size,
        color = "currentColor",
        viewBox = "0 0 40 30",
    }: Props = $props();
</script>

<svg {width} {height} {viewBox}>
    <path
        d="M32.5 15C28.3617 15 25 18.3583 25 22.5C25 26.6417 28.3617 30 32.5 30C36.6383 30 40 26.6417 40 22.5C40 18.3583 36.6383 15 32.5 15ZM36.6667 23.3333H33.3333V26.6667H31.6667V23.3333H28.3333V21.6667H31.6667V18.3333H33.3333V21.6667H36.6667V23.3333ZM6.66667 23.3333L13.3333 13.4L17.4667 16.6667L21.6667 10L24.755 14.94C22.6367 17.1117 21.46 20.0883 21.71 23.3333H6.66667ZM24.7 30H0V0H36.6667V12.5017C35.6283 12.0667 34.505 11.7983 33.3333 11.7083V3.33333H3.33333V26.6667H22.5033C23.0233 27.915 23.7783 29.04 24.7 30ZM9.16667 11.6667C7.78667 11.6667 6.66667 10.5483 6.66667 9.16667C6.66667 7.78667 7.78667 6.66667 9.16667 6.66667C10.5467 6.66667 11.6667 7.78667 11.6667 9.16667C11.6667 10.5483 10.5467 11.6667 9.16667 11.6667Z"
        fill={color} />
</svg>
